<template>
  <div class="container">
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Tax Collection
            </th>
            <th class="text-left">
              Due Tax
            </th>
            <th class="text-left">
              Tax On Purchase
            </th>
            <th class="text-left">
              Tax Fall On Refund
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="active">
            <td>{{ taxReport.taxCollection | currency }}</td>
            <td>{{ taxReport.taxCollectionDue | currency }}</td>
            <td>{{ taxReport.taxOnPurchase | currency }}</td>
            <td>{{ taxReport.taxFallOnRefund | currency }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <column-chart :data="chart" />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <line-chart :data="chart" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      taxReport: {},
    };
  },
  computed: {
    chart() {
      const report = this.$data.taxReport;
      return [
        ["Tax Collection", report.taxCollection],
        ["Due Tax", report.taxCollectionDue],
        ["Tax On Purchase", report.taxOnPurchase],
        ["Tax Fall On Refund", report.taxFallOnRefund],
      ];
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    getFromApi() {
      window.axios.get("/tax-report").then((response) => {
        this.$data.taxReport = response.data;
      });
    },
  },
};
</script>
